<template>
  <div class="docal-document-picker">
    <span class="variable-label">
      {{ label }}
    </span>
    <div class="picker-container">
      <div v-if="isLoading" class="picker-loading">
        <spinner size="small" />
      </div>
      <select
        v-else
        v-model="selectedDocumentId"
        class="document-select"
        @change="onSelect"
      >
        <option value="" disabled>
          {{ $t('DOCAL_MODAL.SELECT_DOCUMENT') }}
        </option>
        <option
          v-for="doc in documents"
          :key="doc.document_id"
          :value="doc.document_id"
        >
          {{ doc.file_name }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Spinner from 'shared/components/Spinner.vue';
import DocalAPI from '../../../../api/docal';
import alertMixin from 'shared/mixins/alertMixin';

export default {
  name: 'DocalDocumentPicker',
  components: {
    Spinner,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      documents: [],
      selectedDocumentId: '',
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
    }),
  },
  mounted() {
    this.fetchDocuments();
  },
  methods: {
    async fetchDocuments() {
      this.isLoading = true;
      this.documents = [];
      try {
        const response = await DocalAPI.getDocumentsList(this.accountId);
        if (response.status !== 200) {
          this.showAlert('Failed to load documents. Please try again.', 'error');
          return;
        }
        this.documents = response.data.documents || [];
      } catch (error) {
        console.error('DocalDocumentPicker error:', error);
        this.showAlert('error');
      } finally {
        this.isLoading = false;
      }
    },
    onSelect() {
      const doc = this.documents.find(
        d => d.document_id === this.selectedDocumentId
      );
      this.$emit('document-selected', doc);
    },
  },
};
</script>

<style lang="scss" scoped>
.docal-document-picker {
  display: flex;
  align-items: center;
  margin-bottom: 0.625rem;


  .picker-container {
    flex: 1;
    margin-left: 0.625rem;
  }

  .document-select {
 
    padding: 0.5rem;
    margin-bottom: 0;
  }

  .picker-loading {
    display: flex;
    align-items: center;
    padding: 0.5rem 0;
  }

  .picker-error {
    padding: 0.25rem 0;
  }

  .error-message {
    color: var(--r-500);
    font-size: var(--font-size-small);
  }
}
</style>
